import { Component, OnInit, Input, Inject, ViewChild, Output, EventEmitter } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { LoaderService } from '../../shared/loader/loader.service';
import { retry } from 'rxjs/operators';

@Component({
  selector: 'app-addemailForFollowupReferral',
  templateUrl: './addemailForFollowupReferral.component.html',
  styleUrls: ['./addemailForFollowupReferral.component.scss']
})

export class AddemailForFolloUpReferralComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  spinner: boolean = false;
  showAddButton = false;
  addUpdateParticipantList: any = [] = [];
  emailAssigned: string = '';
  addEmailButtonShow: boolean = false;
  textButton: string = "FollowUp & Send Mail";
  message: string = "";
  personName: string = "";
  textForPerson: string = "";

  constructor(private dialog: MatDialog, private dialog1: MatDialog, private datePipe: DatePipe, public dialogRef: MatDialogRef<AddemailForFolloUpReferralComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService, private loaderService: LoaderService,) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }
  }

  ngOnInit(): void {
    // if (this.data)
    // this.showAddButton = true; 
    this.personName = this.data.selectedRecord.name;
    //this.textForPerson = `This is to inform you that a follow-up has been initiated for ${this.personName}`;
    this.textForPerson = `This is to inform you that a <b>follow-up</b> has been initiated for <b>${this.personName}</b>.`;

    if (this.data.selectedRecord.emails) {
      let emailList = this.data.selectedRecord.emails.split(',');
      emailList.forEach((email: string) => {
        email = email.trim();
        if (email !== "") {
          let toArray = email.split("@");
          let shortName = toArray[0].match(/\b(\w)/g)?.join('') || '';
          var obj = {
            name: "",
            email: email,
            img: "",
            shortName: shortName
          };
          this.addUpdateParticipantList.push(obj);
        }
      });

      // Reset input
      this.emailAssigned = "";
      this.addEmailButtonShow = false;
      if (this.addUpdateParticipantList.length > 0) {
        this.showAddButton = false;
        this.textButton = "FollowUp & Send Mail";
      } else {
        this.showAddButton = true;
      }
    }

  }


  removeParticipant(item: any) {
    const index = this.addUpdateParticipantList.indexOf(item);
    if (index >= 0) {
      this.addUpdateParticipantList.splice(index, 1);
    }
    if (this.addUpdateParticipantList.length > 0) {
      this.showAddButton = false;
      this.textButton = "FollowUp & Send Mail";
    } else {
      this.showAddButton = true;
      // this.textButton="FollowUp";
    }
  }


  //==== For Add Email================//

  addEmail() {
    var check = [];
    check = this.addUpdateParticipantList.filter((x:any) => x.email.toLowerCase() == this.emailAssigned.toLowerCase())

    let toArray = this.emailAssigned.split("@");
    var shortName = toArray[0].match(/\b(\w)/g).join('');
    if (check.length == 0) {
      var obj = {
        name: "",
        email: this.emailAssigned,
        img: "",
        shortName: shortName
      }
      this.addUpdateParticipantList.push(obj);
      this.emailAssigned = "";
      this.addEmailButtonShow = false;
      if (this.addUpdateParticipantList.length > 0) {
        this.showAddButton = false;
        this.textButton = "FollowUp & Send Mail";
      } else {
        this.showAddButton = true;
        // this.textButton="FollowUp";
      }
    } else {
      this.emailAssigned = "";
      this.addEmailButtonShow = false;
      this.toastr.warning('Email allready added.', '', {
        timeOut: 3000,
      });
    }
  }

  emailCheck(searchValue: any) {
    if (searchValue.toLowerCase() == searchValue.toLowerCase().match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')) {
      this.emailAssigned = searchValue;
      this.addEmailButtonShow = true;
    } else {
      this.addEmailButtonShow = false;
    }
  }

  FollowUpAndSendMail() {
    if (this.message == "") {
      this.toastr.warning('Please add a message.', '', {
        timeOut: 3000,
      });
      return;
    }
    if (this.addUpdateParticipantList.length == 0) {
      this.toastr.warning('Please add at least one email.', '', {
        timeOut: 3000,
      });
      return;
    }
    const emails: string[] = this.addUpdateParticipantList?.map(x =>
      x.email?.trim()).filter(email => !!email) || [];

    var ReqModel = {
      referralD: Number(this.data.selectedRecord.referralID),
      message: this.textForPerson + "<br><br>" + this.message?.trim(),
      emails: emails,
      locationID: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    //return;
    this.spinner = true;
    this.loaderService.show();
    this.settingsService.followReferralQueue(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.spinner = false;
          this.loaderService.hide();
          this.dialogRef.close('Added');
          this.toastr.success('Selected referral FollowUp successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.spinner = false;
          this.loaderService.hide();
          // [shared-row-actions 2026-09-29] the follow-up was not recorded: say so
          this.toastr.error(this.responseHolder.message || 'The follow-up was not recorded.', '', { timeOut: 6000 });
        }
      } else {
        this.spinner = false;
        this.loaderService.hide();
      }
    });
  }

  close() {
    this.dialogRef.close();
  }


}
